export default {
  /// <summary>
  /// Hiển thị trên giao diện người dùng
  /// </summary>
  ShowInClient: 1,
  /// <summary>
  /// Không hiển thị trên giao diện người dùng (là trường hợp người dùng đã xóa)
  /// </summary>
  NotShowInClient: 0,
  /// <summary>
  /// Đang phục hồi
  /// </summary>
  Restoring: 2,
  /// <summary>
  /// Đang sao lưu
  /// </summary>
  Backuping: 3,
  /// <summary>
  /// dữ liệu lỗi
  /// </summary>
  Error: 4,
  /// <summary>
  /// Đang tạo dữ liệu
  /// </summary>
  CreateData: 5,
  /// <summary>
  /// Đang chuyển đổi
  /// </summary>
  Converting: 6,
  /// <summary>
  /// Dữ liệu lỗi khi chuyển đổi
  /// </summary>
  ConvertError: 7,
  /// <summary>
  /// Đang sao chép
  /// </summary>
  CopyingData: 8,
  /// <summary>
  /// Dữ liệu lỗi khi sao chép
  /// </summary>
  CopyingDataError: 9,
  /// <summary>
  /// Đang lưu trữ
  /// </summary>
  Storing: 12,

  // Chờ xử lý
  PendingProcess: 13
};
